/* eslint-disable */
import axios from "axios";
import { admBack, personasBack } from "../core/configs/config";
import { formatDate } from "../utils/utils";
import "../utils/axios.interceptor";
import HttpService from '../services/HttpService';
HttpService.configure();

const axiosClient = HttpService.getAxiosClient();
const epGetPersonasJuridicas = "v1/personas-juridicas/";
const epGetPersonasJuridicasHistorial = "v1/personas-juridicas-history/";
const epCreatePersonaJuridica = "v1/create-persona-juridica/";
const epUpdatePersonaJuridica = "v1/update-persona-juridica/";

const epGetPersonaJuridicaById = "v1/persona-juridica-by-id/";
const epGetPersonaJuridicaHistoryById = "v1/persona-juridica-history-by-id/";

const epGetTiposSocietarios = "v1/parametros?tipo_parametro=SOCIETARIOS";

const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getPersonasJuridicas = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener las Personas Fisicas";
  const token = localStorage.getItem("Token");


  if (params.razon_social) {
    _params.razon_social = params.razon_social.toLowerCase();
  }

  if (params.cuit) {
    _params.cuit = params.cuit;
  }

  if (params.email) {
    _params.email = params.email;
  }

  if (params.numero_inscripcion) {
    _params.numero_inscripcion = params.numero_inscripcion;
  }

  if (params.tipo_societario) {
    _params.tipo_societario = params.tipo_societario;
  }

  if (params.fecha_contrato_social) {
    _params.fecha_contrato_social = formatDate(params.fecha_contrato_social);
  }

  // if (params.argentino) {
  //   argentino = params.argentino === "Si" ? false : true;
  //   _params.extranjero = argentino;
  // }

  if (params.rows) {
    _params.rows = params.rows;
  }

  if (params.first) {
    _params.first = params.first;
  }



  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonasJuridicas}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.code;
    // ejemplo de error controlado
    if (_message_code === "err-encontrado") {
      response.messageText = `Detallo el error `;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

export const getPersonasJuridicasHistorial = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Historial de Personas Fisicas";
  const token = localStorage.getItem("Token");

  if (params.razon_social) {
    _params.razon_social = params.razon_social.toLowerCase();
  }

  if (params.cuit) {
    _params.cuit = params.cuit;
  }

  if (params.email) {
    _params.email = params.email;
  }

  if (params.numero_inscripcion) {
    _params.numero_inscripcion = params.numero_inscripcion;
  }

  if (params.tipo_societario) {
    _params.tipo_societario = params.tipo_societario;
  }

  if (params.fecha_contrato_social) {
    _params.fecha_contrato_social = formatDate(params.fecha_contrato_social);
  }





  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonasJuridicasHistorial}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.code;
    // ejemplo de error controlado
    if (_message_code === "err-encontrado") {
      response.messageText = `Detallo el error `;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};



//
// #############################################################################
//
export const getPersonaById = async (idPersona) => {

  let _errorMessage = "Se produjo un error al obtener la persona";
  const token = localStorage.getItem("Token");
  let _params = {};
  _params = {
    id: idPersona
  }

  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonaJuridicaById}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};


//
// #############################################################################
//
export const getPersonaHistoryById = async (idPersona) => {
  console.log('TODO Delete');
  console.log('getPersonaHistoryById - idPersona: ', idPersona);
  console.log('##################');

  let _errorMessage = "Se produjo un error al obtener la persona";
  const token = localStorage.getItem("Token");
  let _params = {};
  _params = {
    id: idPersona
  }

  try {
    const response = await axiosClient.get(`${personasBack}${epGetPersonaJuridicaHistoryById}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

// get tipoSocietario 

export const getTipoSocietario = async () => {
  let _errorMessage = "Se produjo un error al obtener los tipos societarios";
  const token = localStorage.getItem("Token");

  try {
    const response = await axios({
      method: "GET",
      url: `${personasBack}${epGetTiposSocietarios}`,
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}

// create or update persona juridica
export const savePersonaFisica = async (actionCrud, persona) => {
  let _errorMessage = "Se produjo un error al crear la persona";
  const token = localStorage.getItem("Token");

  try {
    // let response = {};
    // if (actionCrud === "create") {
    //   response = await axios({
    //     method: "POST",
    //     url: `${personasBack}${epCreatePersonaJuridica}`,
    //     data: persona,
    //     headers: {
    //       'Authorization': `Bearer ${token}`
    //     },
    //   });
    // } else if (actionCrud === "update") {
    //   response = await axios({
    //     method: "PUT",
    //     url: `${personasBack}${epUpdatePersonaJuridica}`,
    //     data: persona,
    //     headers: {
    //       'Authorization': `Bearer ${token}`
    //     },
    //   });
    // }
    const response = await axiosClient.get(`${personasBack}${epGetPersonaJuridicaById}`, {
      params: _params,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });


    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemTextCaja}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.message_code;
        if (_message_code === "err-area-already-exist") {
          response.messageText = `Ya existe ${unUna} ${nameItemTextCaja} con esa descripción`;
        } else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}